import React, { useState } from 'react';
import styled from 'styled-components';
import { Elements } from '@stripe/react-stripe-js';
import { connect } from 'react-redux';

import { Box, Title1 } from 'components/core';
import { PlanSelect } from 'components/others';
import { StripeForm } from 'containers';

import SettingsActions from 'redux/SettingsRedux';
import ProfileActions from 'redux/ProfileRedux';

import BackgroundImage from 'assets/girl.png';
import BgGradient from 'assets/gradient-bg.svg';
import { colors } from 'styles/theme';
import { transformProgram } from 'utils/transform';
import API from 'services/api';
import { getMainStripeInstance } from 'services/stripe';
import history from 'utils/history';

const Wrapper = styled(Box)`
  min-width: 100vw;
  min-height: calc(100vh - 96px);
  background-size: cover;
  background: url(${BackgroundImage}) no-repeat,
    url(${BgGradient}) no-repeat #080808;
  background-position: top left;
  @media (max-width: 768px) {
    background-position: top center;
  }
  position: relative;
`;

const InnerWrapper = styled(Box)`
  padding: 40px 0;
  margin: 0 auto;
  width: 1180px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 0 0;
  }
`;

const ContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  margin: 0;
  width: 540px;

  @media (max-width: 768px) {
    width: 320px;
  }
`;

export const Divider = styled(Box)`
  background-color: ${colors.text};
  opacity: 0.6;
  height: 1px;
  align-self: stretch;
`;

const PLANS = [
  {
    name: 'promo_1',
    title: 'Search Boost',
    description: ['Program will appear more frequently at top of homepage'],
    price: '2.99 / week',
  },
  {
    name: 'promo_2',
    title: '2x Search Boost',
    description: ['Program will appear 2X more frequently at top of homepage'],
    price: '5.99 / week',
  },
  {
    name: 'promo_5',
    title: '5x Search Boost',
    description: ['Program will appear 5X more frequently at top of homepage'],
    price: '10.99 / week',
  },
  {
    name: 'master',
    title: 'Free with Master',
    description: ['Program will appear 5X more frequently at top of homepage'],
    price: '29 / mo',
  },
];

function PromoteProgramPage({
  loadSettings,
  updateMyProgram,
  match: {
    params: { programId },
  },
}) {
  const [plan, setPlan] = useState('master');

  const handleSubscribe = async (paymentToken) => {
    const newProgram = await API.promoteProgram(programId, plan, paymentToken);
    const transformed = transformProgram(newProgram);
    updateMyProgram(transformed);
    loadSettings();
    history.push('/profile');
  };

  return (
    <Wrapper pt={[4, 8]} pb={[4, 8]} px={2}>
      <InnerWrapper>
        <ContentWrapper>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            alignSelf="stretch"
            minHeight={['unset', 264]}
            mb={[4, 9]}
          >
            <Title1 color="contrastText" mb={3}>
              Program Promotion
            </Title1>
            <Divider mb={6} />
            <PlanSelect
              value={plan}
              onSelect={setPlan}
              plans={PLANS}
              hideBorder
            />
          </Box>
        </ContentWrapper>
        <ContentWrapper ml={[0, 8]}>
          <Title1 color="white" mb={[2, 3]} textAlign={['center', 'left']}>
            Pay with card
          </Title1>
          <Divider mb={[2, 6]} width={[1, 0.5]} />
          <Elements stripe={getMainStripeInstance()}>
            <StripeForm
              onSubmit={handleSubscribe}
              price={2900}
              buttonText="Promote"
            />
          </Elements>
        </ContentWrapper>
      </InnerWrapper>
    </Wrapper>
  );
}

const mapDispatchToProps = (dispatch) => ({
  loadSettings: () => dispatch(SettingsActions.setLoadSettingsRequest()),
  updateMyProgram: (data) => dispatch(ProfileActions.updateMyProgram(data)),
});

export default connect(null, mapDispatchToProps)(PromoteProgramPage);
